import { render } from "./RoadMessageWsHomeTop.vue?vue&type=template&id=4cfb214a"
import script from "./RoadMessageWsHomeTop.vue?vue&type=script&lang=js"
export * from "./RoadMessageWsHomeTop.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/h5/luqiao/home/RoadMessageWsHomeTop.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4cfb214a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4cfb214a', __exports__)) {
    api.reload('4cfb214a', __exports__)
  }
  
  module.hot.accept("./RoadMessageWsHomeTop.vue?vue&type=template&id=4cfb214a", () => {
    api.rerender('4cfb214a', render)
  })

}


export default __exports__